import { useEffect, useState } from 'react';
import { IInvoiceRecord, IInvoiceOrderRecord, IInvoiceLogisticServiceRecord } from 'components/InvoiceSectionOfBillingTab/InvoiceSectionOfBillingTab.types';
import { NudosButton, NudosTextInput } from 'components/NudosComponents';
import NudosDatePicker from 'components/NudosComponents/NudosDatePicker';
import './InvoiceNumberAndEmissionDate.scss';

interface IInvoiceNumberAndEmissionDate {
  handleUpdateOrCreateInvoice: (invoiceRecord: IInvoiceRecord) => Promise<void>;
  invoiceRecord: IInvoiceRecord | IInvoiceOrderRecord | IInvoiceLogisticServiceRecord | undefined;
  isUpdatingOrCreatingInvoice: boolean;
  disabled?: boolean;
}

const InvoiceNumberAndEmissionDate = ({ handleUpdateOrCreateInvoice, invoiceRecord, isUpdatingOrCreatingInvoice, disabled }: IInvoiceNumberAndEmissionDate) => {
  const [invoiceNumber, setInvoiceNumber] = useState<string | null>(null);
  const [invoiceEmissionDate, setInvoiceEmissionDate] = useState<string | null>(null);
  const [isInvoiceDataUpdated, setIsInvoiceDataUpdated] = useState<boolean>(false);

  const isButtonInvoiceNumberDisabled =
    !invoiceNumber ||
    !invoiceEmissionDate ||
    (invoiceNumber === invoiceRecord?.invoiceNumber && invoiceEmissionDate === invoiceRecord?.invoiceEmissionDate) ||
    isUpdatingOrCreatingInvoice ||
    isInvoiceDataUpdated;

  const updateOrCreateInvoiceWithHandler = async ({ invoiceNumber, invoiceEmissionDate }: IInvoiceRecord) => {
    await handleUpdateOrCreateInvoice({ invoiceNumber, invoiceEmissionDate });
    setIsInvoiceDataUpdated(true);
  };

  const setInvoiceData = () => {
    setInvoiceNumber(invoiceRecord?.invoiceNumber || null);
    setInvoiceEmissionDate(invoiceRecord?.invoiceEmissionDate || null);
  }

  useEffect(() => {
    setInvoiceData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceRecord]);

  useEffect(() => {
    if (!isInvoiceDataUpdated) return;
    setIsInvoiceDataUpdated(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNumber, invoiceEmissionDate]);

  
  return (
    <section className="invoiceNumberAndEmissionDate">
      <div className="containerInvoiceNumber">
        <NudosTextInput
          isDeactivated={disabled}
          inputPadding={8}
          styleLabel="customMyLabel"
          label="N° factura*"
          defaultValue={invoiceRecord?.invoiceNumber || ''}
          isFilled={!!invoiceRecord?.invoiceNumber}
          handleChange={e => setInvoiceNumber(e || null)}
          placeholder="N. Factura"
        />
      </div>
      <div className="containerInvoiceEmissionDate">
        <NudosDatePicker
          isDeactivated={disabled}
          label="Fecha de facturación*"
          customLabel="invoiceEmissionDateLabel"
          isFilled={!!invoiceRecord?.invoiceEmissionDate}
          defaultValue={invoiceRecord?.invoiceEmissionDate || ''}
          updateCurrentValueCallback={e => setInvoiceEmissionDate(e || null)}
        />
      </div>
      <div className="containerButtonInvoiceNumber">
        <NudosButton
          customClassName="mySizeButton"
          customWidth="80px"
          customHeight="18px"
          buttonText="Guardar"
          isButtonLoading={isUpdatingOrCreatingInvoice}
          handleClick={() => updateOrCreateInvoiceWithHandler({ invoiceNumber, invoiceEmissionDate })}
          isButtonDisabled={isButtonInvoiceNumberDisabled}
        />
      </div>
    </section>
  );
};

export default InvoiceNumberAndEmissionDate;